export enum EFormInputTypes {
  TEXT = 'text',
  PASSWORD = 'password',
  NUMBER = 'number',
  SELECT = 'select',
  MULTISELECT_BOX = 'multiselect-box',
  DATE = 'date',
  DATE_RANGE = 'date-range',
  CHECKBOX = 'checkbox',
  COLOR = 'color',
  TEXTAREA = 'textarea',
  SWITCH = 'switch',
  TEXT_EDITOR = 'text-editor',
  RADIO = 'radio',
  SELECT_BUTTON = 'select-button',
  FILES = 'files',
  SINGLE_FILE = 'single-file',
  HIDDEN = 'hidden',
  SLOT = 'slot',
}
